<template>
  <div class="input-group pt-2 pb-2 align-items-center">
    <div class="form-control h-auto grey-label readonly-input" style="border-radius: 0.25rem  !important; min-height: 38px;">
      <ul v-html="formattedValue" class="" style="margin: 0 !important; list-style-type: circle;"></ul>
    </div>
    <b-button
        data-test-path="select-button"
        class="form-button ml-1 d-none d-xl-inline-block"
        variant="plm-action"
        @click="changeParent(filter)"
    >
      <font-awesome-icon icon="pencil-alt" class="mr-2"/>
      {{ $tr("Select", "Select") }}
    </b-button>
    <b-button
        class="form-button-icon ml-1 d-xl-none"
        variant="plm-action"
        @click="changeParent(filter)"
    >
      <font-awesome-icon icon="pencil-alt" class="mr-2"/>
    </b-button>
    <b-button
        data-test-path="clear-button"
        class="form-button ml-1 d-none d-xl-inline-block"
        variant="plm-action"
        @click="clearFilters(filter)"
    >
      <font-awesome-icon icon="broom" class="mr-2"/>
      {{ $tr("Clear", "Clear") }}
    </b-button>
    <b-button
        class="form-button-icon ml-1 d-xl-none"
        variant="plm-action"
        @click="clearFilters()"
    >
      <font-awesome-icon icon="broom" class="mr-2"/>
    </b-button>
  </div>
</template>

<script>

import FormsLoader from "@/components/forms/FormsLoader";
import FormsActions from "@/components/forms/FormsActions";
import FormsAI from "@/components/forms/FormsAI";
import ReportFilterSpec from "@/server/com/silkplm/engine/reports/filters/ReportFilterSpec";
import NumericFilterSpec from "@/server/com/silkplm/engine/forms/schema/definition/filters/NumericFilterSpec";
import ApplicationUserFilterDataModel from "@/server/com/silkplm/engine/reports/filters/ApplicationUserFilterDataModel";
import {isProxy, toRaw} from 'vue';
import StreamingEngine from "@/components/forms/StreamingEngine";
import {
  checkIfEnabledByOrganizationFormsSettingsForForm
} from "@/components/forms/customizations/plm/EntityEditFormService";

export default {
  name: "SelectFilterActivityInput",
  components: {},
  beforeMount() {
  },
  mounted() {
  },
  props: {
    filter: {default: null, type: ReportFilterSpec},
  },
  watch: {},
  methods: {
    async updateFormattedValue(newVal) {
      if (Array.isArray(newVal) && newVal.length > 1) {
        let listItems = "";
        for (let newValKey of newVal) {
          const title = await Rpc.Forms.getEntityLabel(FormsLoader.detectFormConfig(this.filter.className).formClassLong, newValKey);
          listItems += `<li>${title}</li>`;
        }
        this.formattedValue = listItems;
      } else if (Array.isArray(newVal) && newVal.length === 1) {
        const title = await Rpc.Forms.getEntityLabel(FormsLoader.detectFormConfig(this.filter.className).formClassLong, newVal[0]);
        this.formattedValue = `<li>${title}</li>`;
      } else {
        this.formattedValue = "";
      }

    },

    async clearFilters(reportFilter) {
      this.selectedValue = [];
      await this.updateFormattedValue([]);
      this.$emit('data-updated', reportFilter.id, {filterIds: [], filterType: "DictionaryFilterSpec"});
    },

    async changeParent(reportFilter) {
      let filter = null;
      let ids = [];
      ids = await Rpc.plm.services.ReportsFiltersService.getAllIdsForActivity(reportFilter.className, reportFilter.title);

      let activity = await FormsActions.showMultiSelectListFromIds(
          reportFilter.className,
          {filter}, ids);
      let result = await activity.getResult();

      if (result?.materialize) {
        await result.materialize();
      }

      if (result && result.length) {
        result = result.map(product => product.id);
      }
      if (result === null) {
        this.selectedValue = [];
      } else if (result !== undefined) {
        this.selectedValue = result;
        await this.updateFormattedValue(result);
        this.$emit('data-updated', reportFilter.id, {
          filterIds: result,
          filterType: "DictionaryFilterSpec",
          clazz: reportFilter.className,
          title: reportFilter.title
        });
      }
    },
  },

  data: () => ({
    readOnly: true,
    selectedValue: null,
    formattedValue: "",
  })
}
</script>

<style scoped>

</style>
